import { FC } from "react";

import { Box, Theme, useTheme } from "@mui/material";

export type ExpandedDescriptionProps = {
  sanitizedDescription: string;
};

export const ExpandedDescription: FC<ExpandedDescriptionProps> = ({ sanitizedDescription }) => {
  const theme = useTheme<Theme>();

  return (
    <Box
      sx={{
        ...theme.typography.body2,
        color: theme.palette.forms.text.moderate,
        maxWidth: "100%",
        overflowWrap: "anywhere",
        ["& *"]: {
          maxWidth: "100%",
          color: "inherit !important",
        },
        ["& p"]: {
          width: "auto !important",
          marginInline: "0 !important",
        },
      }}
      dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
    />
  );
};
